import ls from "localstorage-slim";
import { LOBBIE_STORAGE } from "src/constants";

// Basic storage primitives without dependencies on other modules
export const basicLocalGet = (key: string, defaultValue?: string): string | null => {
    try {
        const value = (ls?.get(key) as string) || null;
        return value || defaultValue || null;
    } catch (error) {
        console.error("Error accessing localStorage:", error);
        return defaultValue || null;
    }
};

export const basicLocalSet = (key: string, value: string | undefined): void => {
    if (!value) return;
    try {
        ls?.set(key, value);
    } catch (error) {
        console.error("Error setting localStorage:", error);
    }
};

// Initial location loading functions that don't depend on other modules
export const getInitialLocationId = (): number | undefined => {
    const accountIdStr = basicLocalGet(LOBBIE_STORAGE.Local.Staff.Account.ID.V2);
    if (!accountIdStr) return undefined;

    const locationIdStr = basicLocalGet(LOBBIE_STORAGE.Local.Staff.Location.ID.V2);
    return locationIdStr ? Number(locationIdStr) : undefined;
};

export const getInitialMultiLocationsIds = (): number[] => {
    try {
        const stored = basicLocalGet(LOBBIE_STORAGE.Local.Staff.Locations.Multiple);
        if (!stored) return [];

        return stored.split(",").map(Number).filter(Boolean);
    } catch (error) {
        console.error("Error parsing multiLocations:", error);
        return [];
    }
};
